export { default } from "./WnCMainCanvas";
export { WnCMainCanvas } from "./WnCMainCanvas";